import React from "react";
import Auth from "../auth/Auth";
import SorTable from "../base/SorTable";
import API from "../base/API";
import Link from "../base/Link";
import Storage from "../base/Storage";
import DeleteButton from "../base/DeleteButton";
import { translate } from "../base/Translation";

export default class UserList extends Auth {
	constructor(props) {
		super(props);

		this.api = new API({
			get_users: "/user?limit_from=:from&limit_max=:to&brand=:brand",
			delete_user: "/user/delete/:user"
		});

		this.state = {
			limit_from: 0,
			limit_to: 99999,
			users: [],
			tableData: [],
			tableColumns: [
				{ name: "name", display: translate("Meno"), sort: true, width: 19 },
				{ name: "surname", display: translate("Priezvisko"), sort: true, width: 15 },
				{ name: "brands", display: translate("Značky"), sort: false, width: 30 },
				{ name: "role", display: translate("Rola"), sort: true, width: 17 },
				{ name: "email", display: translate("Email"), sort: true, width: 15 },
				{ name: "options", display: " ", width: 4 }
			]
		}
	}

	convertDataForTable(data) {
		return data.map(function (user) {
			let data = {};
			data.id = user.id;
			data.name = <Link to={"/users/edit/" + user.id} textIfNoAccess={true} permission="UserEdit">{user.name}</Link>;
			data.surname = <Link to={"/users/edit/" + user.id} textIfNoAccess={true} permission="UserEdit">{user.surname}</Link>;
			data.email = user.email;
			data.role = user.role;
			data.options = (
				<div style={{ textAlign: "right" }}>
					<DeleteButton onClick={this.onDelete.bind({ user: user.id, currentComponent: this })} permission="UserNew" />
				</div>
			);

			data.brands = user.brands.map((brand, index) => {
				return brand.name
			}).join(", ");

			return data;
		}.bind(this));
	}

	fetchData() {
		let brandFilter = Storage.get("brand_filter");

		this.api.request({
			cache: true,
			route: "get_users",
			params: { from: this.state.limit_from, to: this.state.limit_to, brand: (brandFilter ? brandFilter.id : "all") },
			data: this.state.vehicle,
			success: (response) => {
				let tableData = this.convertDataForTable(response);
				this.setState({ users: response, tableData });
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	onDelete() {
		this.currentComponent.api.request({
			route: "delete_user",
			params: { user: this.user },
			success: (response) => {
				this.currentComponent.fetchData();
			}
		});
	}

	render() {
		return (
			<SorTable columns={this.state.tableColumns} data={this.state.tableData} headers={true} searchBy="name" title={translate("Používatelia")} right={() => {
				if (Storage.get("allowed_components").indexOf("UserNew") === -1) {
					return "";
				}
				return (
					<div className="pull-right">
						<Link to="/users/add/new" className="btn btn-success btn-sm pull-right"><i className="fa fa-plus" /> {translate("Pridať")}</Link>
					</div>
				)
			}} />
		);
	}

}


// WEBPACK FOOTER //
// ./src/modules/user/UserList.js